document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementsByClassName('cookie__button')[0];
  if (typeof button !== 'undefined') {
    button.onclick = function () {
      document.cookie = 'cookieConsent=true; max-age=31536000';
      document.getElementsByClassName('cookie')[0].classList.add('cookie--hidden');
    };
  }
});

function resetCookieConsent() {
  const mainDomain = (function () {
    const parts = window.location.hostname.split('.');
    if (parts.length > 2) parts.shift();
    return `.${parts.join('.')}`;
  }());

  ['cookie-consent', 'marketing-cookies', 'functional-cookies', 'essential-cookies']
    .forEach((name) => {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${mainDomain}`;
    });
}

function openCookieBanner() {
  // If the custom element is already registered, just create one
  if (customElements.get('cookie-consent-banner')) {
    document.body.appendChild(document.createElement('cookie-consent-banner'));
  } else {
    // Fallback: if the script is not loaded yet, let GTM load the script anyway
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'show_cookie_banner' });
  }
}

if (document.getElementById('show-cookie-banner')) {
  document.getElementById('show-cookie-banner').addEventListener('click', () => {
    if (window.Cookiebot) {
      window.Cookiebot.renew(); // If Cookiebot is used, renew the consents
      return;
    }

    // New cookie-banner implementation
    resetCookieConsent(); // Reset all consents, otherwise the banner won't show again
    openCookieBanner(); // Re-open the banner
  });
}
